// Mood Board Color
export const BG_PRIMARY = '#9db2c6';
export const BG_SECONDARY = '#fff8ed';
export const BG_ALTERNATIVE = '#687e96';

export const ASSETS_PRIMARY = '#ffebca';
export const BG_LAYER = '#9db2c6';

// Text Color
export const TEXT_PRIMARY = '#ffffff'; //brown dark
export const TEXT_SECONDARY = '#ffebca'; // Title color section
export const TEXT_ALTERNATIVE = '#687e96';

// Music & Navigation Color
export const NAVIGATION_COLOR = 'rgb(102, 52, 51)'; // Warna BG
export const ICON_NAVIGATION_COLOR = 'white'; // Warna Iconnya

// Default Button Color
export const BUTTON_PROPS = {
  _active: { opacity: '.8' },
  _hover: { opacity: '.8' },
  _focus: { opacity: '.8' },
};
